var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Ølkort")]),_vm._l((_vm.beers),function(beer){return _c('Beer',{key:beer.id,attrs:{"beer":beer}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }